import { motion } from "framer-motion";

const DELIVERY_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/r3lcaxfx_04fc1148-ccb6-4c91-bd4d-3ed676cd58cb.png";

export const ProfessionalDelivery = () => (
  <section data-testid="professional-delivery-section" className="bg-baseLight px-6 pt-[30px] pb-[25px] sm:py-[40px] lg:px-12 lg:py-[90px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -18 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6"
        >
          <div className="h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]">
            <img
              src={DELIVERY_IMAGE}
              alt="Professionals reviewing plans at an industrial site"
              className="h-full w-full object-cover object-center"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 18 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-6"
        >
          <h2
            data-testid="professional-delivery-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            The right expertise for each part<br className="hidden lg:block" /> of the project
          </h2>
          <p data-testid="professional-delivery-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
            Off-Grid Hydrogen is being structured as a systems integrator supported by qualified
            technology partners, equipment suppliers and licensed professionals.
          </p>
          <p className="mt-[27px] lg:mt-4 text-[15px] leading-relaxed text-inkSoft">
            Projects requiring regulated professional engineering in British Columbia will be
            prepared or supervised by appropriately licensed BC professionals, including a BC
            P.Eng. / EGBC Responsible Registrant where required.
          </p>
          <p className="mt-[27px] lg:mt-4 text-[15px] leading-relaxed text-inkSoft">
            Specialized installation work will be coordinated with appropriately qualified<br className="hidden lg:block" /> and licensed contractors.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
